module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [(_vm.channel_type == '1') ? _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.8em",
      "height": "1.8em",
      "position": "relative",
      "top": "2px",
      "left": "3px",
      "padding-right": "7px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconweixin1"
    }
  })])]) : (_vm.channel_type == '2') ? _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.4em",
      "height": "1.4em",
      "position": "relative",
      "top": "2px",
      "left": "3px",
      "padding-right": "7px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconqq",
      "id": "icon_qq"
    }
  })])]) : (_vm.channel_type == '3') ? _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.3em",
      "height": "1.3em",
      "position": "relative",
      "top": "2px",
      "left": "2px",
      "padding-right": "5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_icondingding1"
    }
  })])]) : (_vm.channel_type == '4') ? _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "2.0em",
      "height": "2.0em",
      "position": "relative",
      "top": "0px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconyoujian1"
    }
  })])]) : (_vm.channel_type == '5') ? _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.8em",
      "height": "1.8em",
      "position": "relative",
      "top": "2px",
      "padding-right": "2px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconduanxin6"
    }
  })])]) : _c('span', [_c('svg', {
    staticClass: "icon",
    staticStyle: {
      "width": "1.5em",
      "height": "1.5em",
      "position": "relative",
      "top": "4px",
      "left": "1px",
      "padding-right": "2px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#the_third_iconqita4"
    }
  })])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('span', {
    staticClass: "show_title"
  }, [_vm._v(_vm._s(_vm.name))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-14a73797","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/channel_type_show.vue
// module id = SNUo
// module chunks = 81